<template>
    <div class="news-content" >
        <h2>{{news.title}}</h2>
        <p>{{news.createtime}}<span v-show="news.views"><i class="iconfont icon-yanjing"></i>{{news.views}}</span></p>
        <div class="news-text" v-html="news.content"></div>
        <div style="display: none">
            <div class="end">-&nbsp;THE&nbsp;END&nbsp;-</div>
            <div class="swiper-controller">
                <div><i></i>上一篇</div>
                <span>|</span>
                <div><i></i>下一篇</div>
            </div>
            <br>
            <i class="back">原</i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsContent',
    props:{
        news: Object
    },
    data () {
        return {
        }
    },
    methods: {
        getDate (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            return Y+M+D;
        },
        imgShow (str) {
            var reg = new RegExp(/(src=")([^"]*")/g)
            var arr = reg.exec(str)
            if(!arr){
                return str
            }
            else{
                return str.replace(reg,"$1https://guanwang.wsandos.com$2")
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .news-text >>> img
        width: 100%
    .news-content
        width: 100%
        h2
            font-size: 34px
            line-height: 40px
            margin-bottom: 50px
            font-weight: bold
            font-stretch: normal
            line-height: 48px
            letter-spacing: 1px
            color: #333
        p
            font-size: 16px
            color: #333
            margin-bottom: 80px
            letter-spacing: 1px
            line-height: 20px
            span
                color: #999
                margin-left: 2em
                i
                    font-size: 14px
                    margin-right: 0.3em
        .news-text
            width: 100%
            padding-bottom: 20%
        >div
            margin-top: 5em
            text-align: center
            .end
                padding-bottom:  1em
                color: #666
                border-bottom: 1px solid #999
            .swiper-controller
                display: inline-block
                background: #000
                color: #fff
                margin: 1em 0 1.6em
                >div
                    display: inline-block
                    padding: 1em 2em
            .back
                display: inline-block
                width: 50px
                height: 50px
                line-height: 50px
                font-size: 16px
                background: #ccc
                border-radius: 30px
</style>


// WEBPACK FOOTER //
// src/components/pc/NewsContent.vue